class ModuleSocket {
    constructor(template) {
        this.template = template;
        this.socket = null;
    }
    /**
     * สร้าง instance ของ socket
     * @param {string} url - url ของ socket
     * @param {object} options - options ของ socket
     * @author เต้ย
     */
    init(url = null, options = {}) {
        const target = url || this.template.baseUrlSocket;

        // หนึ่งหน้ามีหลาย instance ที่ init socket (Template ถูก extend หลายชั้น +
        // notifications) — ใช้ connection เดียวร่วมกันต่อ url เดียวกัน แต่ละ instance
        // ยัง join ห้องและ bind event ของตัวเองได้ตามปกติ
        ModuleSocket._shared = ModuleSocket._shared || {};

        if (!ModuleSocket._shared[target]) {
            ModuleSocket._shared[target] = io(target, options);
        }

        this.socket = ModuleSocket._shared[target];
    }

    /**
     * เพิ่ม event listener สำหรับ socket
     * @param {string} event - event ของ socket
     * @param {function} callback - callback ของ socket
     * @author เต้ย
     */
    on(event, callback) {
        this.socket.on(event, callback);
    }

    /**
     * ส่ง event ไปยัง socket
     * @param {string} event - event ของ socket
     * @param {object} data - data ของ socket
     * @author เต้ย
     */
    emit(event, data) {
        this.socket.emit(event, data);
    }

    /**
     * เข้าร่วมห้อง
     * @param {string} room - ห้องที่จะเข้าร่วม
     * @author เต้ย
     */
    join(room) {
        this.socket.emit('join_room', { roomId: room });
    }

    /**
     * ออกจากห้อง
     * @param {string} room - ห้องที่จะออกจาก
     * @author เต้ย
     */
    leave(room) {
        this.socket.emit('leave_room', { roomId: room });
    }
}
